import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { PeopleIcon } from 'secondstep-components'
import ReportsDropdown from './ReportsDropdown'
import { CLICK, ENTER, CLOSE, USER_MANAGEMENT_PATH } from './constants'
import {
  CloseModalButton,
  LeaderContainer,
  SchoolPageModalText,
  StyledClosableModal,
  StyledDescription,
  SvgWithBodyCopy,
  StyledAccessibleTextLink,
  StyledHeader,
  StyledSvg,
  SchoolModalText,
} from './component.styles'
import NavigationHelper from 'layers/navigation/navigationHelper'

const K8ReportingLeaderTools = ({
  classesCount,
  entry,
  error,
  historicalReportingOnClick,
  historicalReports,
  isDownloadingHistoricalReportData,
  isFetchingDocumentUrl,
  isSchoolSummary,
  navigationEvent,
  onClickCurrentYear,
  pendingInvitations,
  selectedSite,
}) => {
  const [isModalShown, setModalIsShown] = useState(false)

  const {
    schoolModalHeader1 = '',
    schoolModalHeader2 = '',
    schoolModalIcon1,
    schoolModalIcon2,
    schoolModalIcon3,
    schoolPageModalIcon4,
    schoolModalText1 = '',
    schoolModalText2 = '',
    schoolModalText3 = '',
    schoolPageModalText4 = '',
    schoolCsvDownloadTooltip,
  } = entry || {}

  const schoolModalIcon1Url = schoolModalIcon1?.file?.url || ''
  const schoolModalIcon2Url = schoolModalIcon2?.file?.url || ''
  const schoolModalIcon3Url = schoolModalIcon3?.file?.url || ''
  const schoolModalIcon4Url = schoolPageModalIcon4?.file?.url || ''

  const openModal = ({ event }) => {
    if (isModalShown || (event.type !== CLICK && event.key !== ENTER)) {
      return
    }

    setModalIsShown(true)
  }
  const closeModal = () => {
    setModalIsShown(false)
  }

  const csvDropdownData = {
    classesCount,
    error,
    historicalReports,
    historicalReportingOnClick,
    isFetching: isFetchingDocumentUrl || isDownloadingHistoricalReportData,
    onClickCurrentYear,
    schoolCsvDownloadTooltip,
  }

  return (
    <LeaderContainer data-testid="LeaderContainer">
      <ReportsDropdown
        {...csvDropdownData}
        isFetchingDocumentUrl={isFetchingDocumentUrl}
      />
      {isSchoolSummary && (
        <StyledAccessibleTextLink
          ariaLabel="manage-users-link"
          dataTestId="manage-users-link"
          onClick={() =>
            navigationEvent(
              `${USER_MANAGEMENT_PATH}/${selectedSite}`,
              NavigationHelper.types.OPEN,
            )
          }
        >
          <PeopleIcon /> Manage Users
        </StyledAccessibleTextLink>
      )}
      <StyledAccessibleTextLink
        ariaLabel="manage-users-link"
        dataTestId="manage-users-link"
        onClick={event =>
          openModal({
            event,
          })
        }
        onKeyPress={event =>
          openModal({
            event,
          })
        }
      >
        <PeopleIcon /> Supporting Instructors
      </StyledAccessibleTextLink>
      <StyledClosableModal onClose={closeModal} show={isModalShown}>
        {schoolModalHeader1 && (
          <StyledHeader>{schoolModalHeader1}</StyledHeader>
        )}
        {schoolModalHeader2 && (
          <StyledDescription>{schoolModalHeader2}</StyledDescription>
        )}
        {(!!schoolModalIcon1Url || !!schoolModalText1) && (
          <SvgWithBodyCopy>
            {schoolModalIcon1Url && <StyledSvg src={schoolModalIcon1Url} />}
            {schoolModalText1 && (
              <SchoolModalText>{schoolModalText1}</SchoolModalText>
            )}
          </SvgWithBodyCopy>
        )}
        {(!!schoolModalIcon2Url || !!schoolModalText2) && (
          <SvgWithBodyCopy>
            {schoolModalIcon2Url && <StyledSvg src={schoolModalIcon2Url} />}
            {schoolModalText2 && (
              <SchoolModalText>{schoolModalText2}</SchoolModalText>
            )}
          </SvgWithBodyCopy>
        )}
        {(!!schoolModalIcon3Url || !!schoolModalText3) && (
          <SvgWithBodyCopy>
            {schoolModalIcon3Url && <StyledSvg src={schoolModalIcon3Url} />}
            {schoolModalText3 && (
              <SchoolModalText>{schoolModalText3}</SchoolModalText>
            )}
          </SvgWithBodyCopy>
        )}
        {(!!schoolModalIcon4Url || !!schoolPageModalText4) && (
          <SvgWithBodyCopy>
            {schoolModalIcon4Url && <StyledSvg src={schoolModalIcon4Url} />}
            {schoolPageModalText4 && (
              <SchoolPageModalText>{schoolPageModalText4}</SchoolPageModalText>
            )}
          </SvgWithBodyCopy>
        )}
        <CloseModalButton data-testid="closeButton" onClick={closeModal}>
          {CLOSE}
        </CloseModalButton>
      </StyledClosableModal>
    </LeaderContainer>
  )
}

K8ReportingLeaderTools.propTypes = {
  classesCount: PropTypes.number,
  entry: PropTypes.object,
  error: PropTypes.object,
  historicalReportingOnClick: PropTypes.func,
  historicalReports: PropTypes.array,
  isDownloadingHistoricalReportData: PropTypes.bool,
  isFetchingDocumentUrl: PropTypes.bool,
  isSchoolSummary: PropTypes.bool,
  navigationEvent: PropTypes.func,
  onClickCurrentYear: PropTypes.func,
  pendingInvitations: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  selectedSite: PropTypes.number,
}

export default K8ReportingLeaderTools
